module.exports = __webpack_public_path__ + "static/img/ryzs.b6cbb76e.png";